export default "__VITE_ASSET__DUH19rsC__"